import { AccordionSummary, Stack, Typography } from "@mui/material";
import type { ProductCode } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { ExpandMore } from "@mui/icons-material";
import { getA11yIDs } from "Components/Shared/Merchant/Products/AppProducts/ProductAccordion/utils";
import { ActiveChip } from "./ActiveChip";
import { PreviewChip } from "./PreviewChip";
import { DefaultChip } from "./DefaultChip";

const COMPONENT_RESOURCES = Resources.Components.Merchant.AppProducts;

type Props = {
  code: ProductCode;
  isActive: boolean;
  isDefault?: boolean;
  isPreviewOnly?: boolean;
};

export const AccordionHeader = ({
  code,
  isActive,
  isDefault,
  isPreviewOnly,
}: Props) => {
  const { t } = useResource();

  const { headerID, contentID } = getA11yIDs(code);

  return (
    <AccordionSummary
      id={headerID}
      aria-controls={contentID}
      expandIcon={<ExpandMore sx={{ minWidth: 50 }} />}
    >
      <Stack p={4} pr={2}>
        <Typography
          variant="h6"
          component="h3"
          display="flex"
          alignItems="center"
          gutterBottom
          gap={2}
        >
          {t(COMPONENT_RESOURCES.Products[code])}
          {isActive && <ActiveChip />}
          {isPreviewOnly && <PreviewChip />}
          {isDefault && <DefaultChip />}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t(COMPONENT_RESOURCES.ProductDescriptions[code])}
        </Typography>
      </Stack>
    </AccordionSummary>
  );
};
